/*
    node_js
    2/17/2021 12:43 AM
    by Oleksandr
*/
import React, {useEffect, useRef, useState} from 'react'
import socketIOClient from 'socket.io-client'
import {createPeerConnection} from "./RTCModule";

const ClientSocket = (context) => {
    const {
        username, room, flights, tickValue, timeValue,
        isCon, isPlt, setTimeValue, setFlights,
        createOfferRes, onOffer, answerRes, onAnswer, candidates, setCandidate,
        getLocalStream, localStream, setPeerConnections, peerConnections, remoteVideoRef,
        setRemoteStreams, remoteStreams,
        setUpdateFlightsTime, setLabel, setUsers
    } = context
    const socketRef = useRef()
    // const [users, setUsers] = useState([])
    const [status, setStatus] = useState('Waiting for connection')
    // const [username, setUserName] = useState('lviv' + parseInt(Math.random() * 10))

    useEffect(() => {
        if (answerRes === null) return
        socketRef.current.emit('answer', {answer: answerRes})
        // console.log(answerRes)
    }, [answerRes])

    useEffect(() => {
        socketRef.current = socketIOClient.connect('https://lvivacc.online:8443', {transports:['polling']})


        socketRef.current.emit('join', {username: username, room: room}, error => {
            console.log('join', room)
            if (error) {
                // setError(error);
                console.log(error)
            }
        })
        socketRef.current.on('connection-success', async data => {

            await getLocalStream()
            socketRef.current.emit('onlinePeers', {socketID: {local: socketRef.current.id}})

            // console.log(data.success)
            const status = data.peerCount > 1 ? `Connected to ${room}` : `Connected to ${room}\nWaiting for other users...`
            setLabel(status)
            setStatus(status)
        })
        socketRef.current.on('joined-peers', data => {

            const status = data.peerCount > 1 ? `Connected to ${room}` : `Connected to ${room}\nWaiting for other users...`
            setLabel(status)
            setStatus(status)
        })
        socketRef.current.on('roomData', (data) => {
            setUsers(data.users)
            console.log(data.users)
        })

        socketRef.current.on('timeValue', (data) => {
            if (isCon) {
                setTimeValue(data);
            }
        })
        socketRef.current.on('flights', (data) => {
            if (isCon) {
                data.flights.map((flt=>{
                    let indexOfFlight = flights.map(e => e.id).indexOf(flt.id);
                    if (indexOfFlight>=0) {
                        flights[indexOfFlight].flight = flt.flight;
                    }
                    else {
                        flights.push(flt)
                    }
                }))
                setFlights(flights);
                setUpdateFlightsTime(new Date());
            }
        })

        return () => {
            console.log('disconnectManual')
            socketRef.current.emit('disconnectManual')
        }
    }, [username, room, candidates])

    useEffect(() => {
        console.log('peerConnections', peerConnections)
        const sdpConstraints = {
            'mandatory': {
                'OfferToReceiveAudio': true,
                'OfferToReceiveVideo': true
            }
        }
        const onlinePeerHandler = socketID => {
            console.log('connected peers ...', socketID)

            createPeerConnection(socketID, setPeerConnections, localStream, socketRef, remoteVideoRef, setRemoteStreams, remoteStreams,
                    pc => {
                // 2. Create Offer
                if (pc)
                    pc.createOffer(sdpConstraints)
                        .then(sdp => {
                            pc.setLocalDescription(sdp)

                            socketRef.current.emit('offer', {
                                payload: sdp,
                                socketID: {
                                    local: socketRef.current.id,
                                    remote: socketID
                                }
                            })
                        })
            })
        }

        const offerHandler = data => {
            createPeerConnection(data.socketID, setPeerConnections, localStream, socketRef, remoteVideoRef, setRemoteStreams, remoteStreams,
                    pc => {
                // pc.addStream(localStream)

                pc.setRemoteDescription(new RTCSessionDescription(data.sdp)).then(() => {
                    // 2. Create Answer
                    pc.createAnswer(sdpConstraints)
                        .then(sdp => {
                            pc.setLocalDescription(sdp)

                            socketRef.current.emit('answer', {
                                payload: sdp,
                                socketID: {
                                    local: socketRef.current.id,
                                    remote: data.socketID
                                }
                            })
                        })
                })
            })
        }

        const answerHandler = async data => {
            // get remote's peerConnection
            // console.log(peerConnections,peerConnections[data.socketID], data.socketID, data)
            const pc = peerConnections[data.socketID]
            // console.log(pc)
            pc.setRemoteDescription(await new RTCSessionDescription(data.sdp))
        }

        const candidateHandler = (data) => {
            // get remote's peerConnection
            const pc = peerConnections[data.socketID]

            if (pc)
                pc.addIceCandidate(new RTCIceCandidate(data.candidate))
        }

        const disconnectHandler = data => {
            // console.log(data)
            const status = data.peerCount > 1 ? `Connected to ${room}` : `Connected to ${room}\nWaiting for other users...`
            const remoteStreamsNew = remoteStreams.filter(stream => stream.id !== data.socketID)
            // console.log(remoteStreams, remoteStreamsNew);
            setRemoteStreams(remoteStreamsNew);
            setLabel(status);
            setStatus(status);
        }

        socketRef.current.on('offer', offerHandler)
        socketRef.current.on('online-peer', onlinePeerHandler)
        socketRef.current.on('answer', answerHandler)
        socketRef.current.on('candidate', candidateHandler)
        socketRef.current.on('peer-disconnected', disconnectHandler)
        return () => {
            socketRef.current.off('online-peer', onlinePeerHandler)
            socketRef.current.off('offer', offerHandler)
            socketRef.current.off('answer', answerHandler)
            socketRef.current.off('candidate', candidateHandler)
            socketRef.current.off('peer-disconnected', disconnectHandler)

        }
    }, [localStream, peerConnections, remoteVideoRef, remoteStreams])

    useEffect(() => {
        if (flights.length === 0 || isCon) return;
        // console.log('emit flights');
        // console.log(flights.map((flt)=> flt.flight[tickValue]));
        let flTest = JSON.parse(JSON.stringify(flights));
        // flTest = flTest.map((flt) => flt);

        socketRef.current.emit('flights', {
            flights: flTest.filter((flt => tickValue + flt.timeShift >= 0)).map((flt) => {
                let index = tickValue + flt.timeShift;
                flt.flight = [flt.flight[index]];
                return flt;
            })
        }, error => {
            if (error) {
                console.log(error);
            }
        });
    }, [tickValue]);

    useEffect(() => {
        if (isPlt) {
            console.log(isPlt, timeValue);
            socketRef.current.emit('timeValue', {timeValue}, error => {
                if (error) {
                    console.log(error);
                }
            });
        }
    }, [timeValue]);
    return (
        <div style={{color: 'green'}}>
            {/*{status}<br/>*/}
            {/*{users.map(user => <div key={user.name}>{user.name}</div>)}*/}
        </div>
    )
}

export default ClientSocket
